<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Tender Type {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else-if="profileId != 0 && this.$attrs.viewMode == true" class="heading-small text-muted mb-4">View Tender Type - {{this.inputName}}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Tender Type - {{this.inputName}}</h6>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div>
                <base-input alternative="" label="Code" placeholder="" v-model="inputCode" input-classes="form-control" />
                <base-input alternative="" label="Name" placeholder="" v-model="inputName" input-classes="form-control" required />
                <base-input alternative="" label="Remark">
                    <textarea rows="4" class="form-control" v-model="inputRemark" />
                </base-input>
            </div>

            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import { mapState } from 'vuex'
    var component_x;
    export default {
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {
            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            this.accountId = this.$attrs.accountId;
            component_x = this
            if (this.profileId > 0) {
                if(this.accountId == undefined){
                    var tender_type_data = await HTTPRequest.getRequest(component_x.endPoint + 'tender_types/' + component_x.profileId , null)
                } else {
                    var tender_type_data = await HTTPRequest.getRequest(component_x.endPoint + 'tender_types/' + component_x.profileId + "?account_id=" + this.accountId , null)
                }

                if (tender_type_data == undefined) {
                    alert("SOMETHING WENT WRONG")
                    // component_x.$router.go()
                } else {
                    if (tender_type_data["error"] == undefined) {
                        component_x.inputName = tender_type_data["name"]
                        component_x.inputCode = tender_type_data["code"]
                        component_x.inputRemark = tender_type_data["remark"]
                    } else {
                        this.errors = tender_type_data["error"].split(",")
                    }
                }
            }
        },
        data: function () {
            return {
                inputName: '',
                inputCode: '',
                inputRemark: '',
                
                errors: [],
                accountId: 0,
            }
        },
        methods: {
            validateForm(){
                this.errors = [];
                this.errors.push(ValidateField.charMinAndMax('Code', this.inputCode, 0, 30));
                this.errors.push(ValidateField.required('Name', this.inputName));

                this.errors.push(ValidateField.charMinAndMax('Name', this.inputName, 0, 50));

                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    var tender_type_payload = {
                        tender_type: {
                            name: this.inputName.trim(),
                            code: this.inputCode.trim(),
                            remark: this.inputRemark,
                            status: 'A',
                        }
                    }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'tender_types?account_id=' + this.accountId, null, tender_type_payload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    var tender_type_payload = {
                        tender_type: {
                            name: this.inputName.trim(),
                            code: this.inputCode.trim(),
                            remark: this.inputRemark,
                        }
                    }
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'tender_types/' + this.profileId + "?account_id=" + this.accountId, null, tender_type_payload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>